/**
 * Account Page Script
 * @description Script para páginas de conta do usuário
 * @version 1.0.0
 * @author Irroba Platform
 */

// Importar módulos globais comuns
import { generateTemplateContent, parseToHtml, replaceString } from '../functions/html_element.js';
import { setCacheData, getCacheData } from '../functions/cache.js';
import { initGlobalComponents } from '../modules/global-components.js';
import formValidation, { initFormValidation } from '../form.js';

/**
 * Inicialização das páginas de conta
 */
const initAccountPage = () => {
    console.log('🚀 Inicializando página de conta...');

    try {
        // Inicializar componentes comuns
        initGlobalComponents();

        // Funcionalidades específicas da conta
        initAccountMenu();
        initAccountForms();
        initAddressForm();
        initPasswordToggle();
        initOrderHistory();

        console.log('✅ Página de conta inicializada com sucesso!');
    } catch (error) {
        console.error('❌ Erro ao inicializar página de conta:', error);
    }
};

/**
 * Inicializa menu de navegação da conta
 */
const initAccountMenu = () => {
    const menuItems = document.querySelectorAll('[data-account-menu-item]');
    const currentPage = window.location.pathname;
    
    menuItems.forEach(item => {
        const itemUrl = item.getAttribute('href');
        
        if (currentPage.includes(itemUrl)) {
            item.classList.add('active');
        }
        
        item.addEventListener('click', function() {
            console.log('📱 Navegando para:', this.textContent.trim());
        });
    });
    
    // Menu mobile toggle
    const menuToggle = document.querySelector('[data-account-menu-toggle]');
    const menu = document.querySelector('[data-account-menu]');
    
    if (menuToggle && menu) {
        menuToggle.addEventListener('click', function() {
            menu.classList.toggle('active');
            console.log('📱 Menu da conta alternado');
        });
    }
};

/**
 * Inicializa validação de formulários da conta
 */
const initAccountForms = () => {
    initFormValidation('[data-validate-form], [data-account-form]');
};

/**
 * Inicializa formulário de endereço com busca de CEP
 */
const initAddressForm = () => {
    const cepInput = document.querySelector('[name="postcode"], [name="cep"]');
    
    if (cepInput) {
        cepInput.addEventListener('blur', function() {
            const cep = this.value.replace(/\D/g, '');
            
            if (cep.length === 8) {
                searchCep(cep);
            }
        });
    }
};

/**
 * Busca CEP na API
 */
const searchCep = (cep) => {
    console.log('🔍 Buscando CEP:', cep);
    
    // Mostrar loading
    const addressFields = document.querySelectorAll('[name="address"], [name="city"], [name="zone"]');
    addressFields.forEach(field => field.disabled = true);
    
    // Buscar CEP via ViaCEP
    fetch(`https://viacep.com.br/ws/${cep}/json/`)
        .then(response => response.json())
        .then(data => {
            if (!data.erro) {
                fillAddressFields(data);
                console.log('✅ CEP encontrado:', data);
            } else {
                alert('CEP não encontrado');
            }
        })
        .catch(error => {
            console.error('❌ Erro ao buscar CEP:', error);
            alert('Erro ao buscar CEP. Tente novamente.');
        })
        .finally(() => {
            addressFields.forEach(field => field.disabled = false);
        });
};

/**
 * Preenche campos de endereço
 */
const fillAddressFields = (data) => {
    const addressField = document.querySelector('[name="address"], [name="address_1"]');
    const cityField = document.querySelector('[name="city"]');
    const stateField = document.querySelector('[name="zone"], [name="state"]');
    const neighborhoodField = document.querySelector('[name="neighborhood"], [name="address_2"]');
    
    if (addressField && data.logradouro) {
        addressField.value = data.logradouro;
    }
    
    if (cityField && data.localidade) {
        cityField.value = data.localidade;
    }
    
    if (stateField && data.uf) {
        stateField.value = data.uf;
    }
    
    if (neighborhoodField && data.bairro) {
        neighborhoodField.value = data.bairro;
    }
    
    // Focar no número
    const numberField = document.querySelector('[name="number"], [name="address_number"]');
    if (numberField) {
        numberField.focus();
    }
};

/**
 * Inicializa toggle de visualização de senha
 */
const initPasswordToggle = () => {
    const passwordToggles = document.querySelectorAll('[data-password-toggle]');
    
    passwordToggles.forEach(toggle => {
        toggle.addEventListener('click', function() {
            const targetId = this.dataset.passwordToggle;
            const passwordField = document.querySelector(`#${targetId}`);
            
            if (passwordField) {
                const type = passwordField.type === 'password' ? 'text' : 'password';
                passwordField.type = type;
                
                // Alternar ícone
                const icon = this.querySelector('i, svg');
                if (icon) {
                    icon.classList.toggle('fa-eye');
                    icon.classList.toggle('fa-eye-slash');
                }
                
                console.log('👁️ Visibilidade da senha alternada');
            }
        });
    });
};

/**
 * Inicializa histórico de pedidos
 */
const initOrderHistory = () => {
    const orderItems = document.querySelectorAll('[data-order-item]');
    
    orderItems.forEach(item => {
        const detailsBtn = item.querySelector('[data-order-details]');
        const detailsPanel = item.querySelector('[data-order-details-panel]');
        
        if (detailsBtn && detailsPanel) {
            detailsBtn.addEventListener('click', function() {
                detailsPanel.classList.toggle('active');
                this.classList.toggle('active');
                
                const orderId = item.dataset.orderItem;
                console.log('📦 Detalhes do pedido:', orderId);
            });
        }
    });
};

/**
 * Inicializa quando o DOM estiver pronto
 */
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccountPage);
} else {
    initAccountPage();
}

export default {
    init: initAccountPage,
    validateForm: formValidation.validateForm,
    formValidation,
    searchCep: searchCep
};
